// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dm-combo-data {\n  margin: 0 0 5px 0;\n}", "",{"version":3,"sources":["webpack://./src/app/components/combo/dm-combo-data/dm-combo-data.component.scss"],"names":[],"mappings":"AAEA;EACI,iBAAA;AADJ","sourcesContent":["\r\n\r\n.dm-combo-data{\r\n    margin: 0 0 5px 0;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
